import { useQuery } from "@tanstack/react-query";
import { ClaimService } from "src/services";
import { APIError } from "src/errors";
import { queryKeys } from "src/constants";

export const useClaim = (claimId: string, claimService: ClaimService) => {
  const {
    data: claim,
    error: fetchError,
    isLoading,
    refetch
  } = useQuery({
    queryKey: queryKeys.claim(claimId),
    queryFn: async () => {
      try {
        return await claimService.getClaimById(claimId);
      } catch (error) {
        if (error instanceof APIError && error.statusCode === 404) {
          return null;
        }
        throw error;
      }
    },
    enabled: !!claimId,
    retry: false
  });

  return { claim, fetchError, isLoading, refetch };
};
